// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createVendorSampleSettings = (client) => ({
    /**
     * `GET /vendor/sample-settings`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetSampleSettings
     * @source packages/modules/b2c-core/src/api/vendor/sample-settings/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/sample-settings", { method: "GET", query, headers }),
});
//# sourceMappingURL=sample-settings.js.map